import React, { useState } from "react";
import { DateRangeController } from "../../metrics/annual-planner/parts/Header";

import moment from "moment";
import { MonthColumn } from "../../metrics/annual-planner/parts/MonthColumn";
import {
  getModifiers,
  getSortedWeekDays,
} from "../../../../utils/annual-planner-helpers";
import { useHorizontalScroll } from "../../../../hooks/useHorizontalScroll";

const from = moment.utc().subtract(3, "months").toDate();
const to = moment.utc().add(9, "months");

const nutritionTargetsHeaders = [
  "Protein (g)",
  "Carbs (g)",
  "Fat (g)",
  "Fiber (g)",
  "kCal",
];

const NutritionPlanCalendar = ({
  startingCalendarDay,
  nutritionPlans,
  stats,
  units,
}) => {
  const [dateFromState, setDateFromState] = useState(from);
  const [dateToState, setDateToState] = useState(to);
  const weekDays = getSortedWeekDays(startingCalendarDay);
  const horizontalScrollRef = useHorizontalScroll("faster");

  const unitLabel = units === "metric" ? "Kg" : "Lbs";

  const athleteStatsHeaders = [
    `Avg Bodyweight (${unitLabel})`,
    `Bodyweight Change (${unitLabel})`,
    "Avg Daily Steps",
    "Avg Daily Sleep (hr)",
  ];

  const toSort = nutritionPlans.map((x) => x);

  const orderedPlans = toSort.sort((a, b) => a.utcStartDate - b.utcStartDate);

  const selectedDays = orderedPlans.map((plan, i) => ({
    fromDate: moment(String(plan.utcStartDate)).toDate(),
    toDate: moment(String(plan.utcEndDate)).toDate(),
    eventColor: "#02AFE4",
    name: `nutrition-${i}`,
  }));

  const modifiersPleaseWork = getModifiers(selectedDays);

  return (
    <div className="nutrition-plan-calendar">
      <DateRangeController
        dateFromState={dateFromState}
        dateToState={dateToState}
        setDateFromState={setDateFromState}
        setDateToState={setDateToState}
        keepRange={true}
      />

      <section role="planner-wrapper">
        <div role="planner-headers">
          <div className="month-row-header">
            {weekDays.map((day, index) => (
              <span className="row-header" key={`week-day-${day}-${index}`}>
                {day.day}
              </span>
            ))}
          </div>

          <div className="athlete-stats-header">
            <span className="row-header-label">Training Day Targets</span>
            {nutritionTargetsHeaders.map((stat, index) => (
              <span className="row-header" key={`${stat}-${index}`}>
                {stat}
              </span>
            ))}
          </div>

          <div className="athlete-stats-header">
            <span className="row-header-label">Rest Day Targets</span>
            {nutritionTargetsHeaders.map((stat, index) => (
              <span className="row-header" key={`${stat}-${index}`}>
                {stat}
              </span>
            ))}
          </div>

          <div className="athlete-stats-header">
            <span className="row-header-label">Body Stats</span>
            {athleteStatsHeaders.map((stat, index) => (
              <span className="row-header" key={`${stat}-${index}`}>
                {stat}
              </span>
            ))}
          </div>
        </div>
        <div role="planner-body" ref={horizontalScrollRef}>
          {Array.apply(null, { length: 12 }).map((e, i) => {
            const monthDate = moment(dateFromState).add(i, "months");
            return (
              <MonthColumn
                key={`month-column-${i}`}
                month={monthDate}
                startingCalendarDay={startingCalendarDay}
                selectedDaysState={undefined}
                setSelectedDaysState={undefined}
                modifiers={modifiersPleaseWork.modifiers}
                modifiersStyles={modifiersPleaseWork.modifiersStyles}
                modifiersClassNames={modifiersPleaseWork.modifiersClassNames}
                athleteStatsState={stats}
                isAnnualPlanner={false}
                nutritionPlans={orderedPlans}
              />
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default NutritionPlanCalendar;
